<template>
  <v-select
    label="nombre"
    :options="medications"
    :reduce="med => mode === 'object' ? med : med.id"
    @search="debounceSearch"
    @input="setChange"
    v-model="selected"
  >
    <template #no-options="{ search }">
      No se encontraron resultados para <strong>{{ search }}</strong>
    </template>
    <template #option="option">
      <div class="d-flex flex-column">
        <strong>{{ option.nombre }}</strong>
        <small class="text-muted" v-if="option.codigo">Código: {{ option.codigo }}</small>
      </div>
    </template>
    <template #search="{ attributes, events }">
      <input
        class="vs__search"
        v-bind="attributes"
        v-on="events"
      />
    </template>
  </v-select>
</template>

<script>
import { debounce } from 'lodash';
import VSelect from 'vue-select';
import ServiceFactory from '../../services/ServiceFactory';
const MedicationDciService = ServiceFactory.get('medication-dci');

export default {
  name: 'VSelectMedicationDci',
  props: ['value', 'mode'],
  components: { VSelect },
  data() {
    return {
      selected: this.value,
      medications: [],
    };
  },
  created() {
    this.debounceSearch = debounce(this.search, 300);
  },
  watch: {
    value(newVal) {
      this.selected = newVal;
    }
  },
  methods: {
    async search(search, loading) {
      if (search === '') {
        return;
      }

      loading(true);
      try {
        let response = await MedicationDciService.search(search);
        this.medications = response.data || [];
      } catch (error) {
        console.error('Error al buscar medication_dci:', error);
        this.medications = [];
      } finally {
        loading(false);
      }
    },
    setChange(value) {
      this.$emit('input', value);
    }
  }
};
</script>
